import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'truncate',
  standalone: true
})
export class FourCharAfterDotPipe implements PipeTransform {

  transform(value: string): string {
    if (!value || typeof value !== 'string') {
      return value;
    }
  
    const atIndex = value.lastIndexOf('@'); // Find the last occurrence of '@'
    if (atIndex === -1) {
      return value; // No '@', return as is
    }
  
    const dotIndex = value.indexOf('.', atIndex); // Find the first '.' after '@'
    if (dotIndex === -1) {
      return value; // No '.' after '@', return as is
    }
  
    const mainPart = value.substring(0, dotIndex); // Part before the '.' after '@'
    const lastPart = value.substring(dotIndex + 1, dotIndex + 5); // Up to 4 chars after the '.'
  
    return `${mainPart}.${lastPart}`;
  }  

}